/**
 * ¿Qué marketplaces tiene integrados esta cuenta? Lo pregunta el menú: «Marketplaces» aparece sólo
 * cuando hay al menos uno (Mercado Libre o Falabella), conectado o en error.
 *
 * Ver `fn_mis_marketplaces_integrados` (migración 20260925157000): devuelve sólo los nombres, nunca
 * los tokens.
 */
import { supabase } from '@/lib/supabase';

export type MarketplaceIntegrado = 'mercadolibre' | 'falabella';

export async function misMarketplacesIntegrados(tenantId: string): Promise<MarketplaceIntegrado[]> {
  const { data, error } = await supabase.rpc('fn_mis_marketplaces_integrados', { p_tenant: tenantId });
  if (error) throw error;
  return (data ?? []) as MarketplaceIntegrado[];
}
